import { ImageUploadEditor, UploadedFile } from "@serenity-is/corelib";
import { isTrimmedEmpty, trimToNull } from "@serenity-is/corelib";

(function () {
    ImageUploadEditor.prototype['set_readOnly'] = function (value) {
        if (this.get_readOnly() !== value) {
            if (value) {
                this.uploadInput.attr('disabled', 'disabled');
                try {
                    this.uploadInput.fileupload('disable');
                }
                catch {
                }
            }
            else {
                this.uploadInput.removeAttr('disabled');
                try {
                    this.uploadInput.fileupload('enable');
                } catch {
                }
            }
            this.updateInterface();
        }
    };

    var oldSetValue = ImageUploadEditor.prototype["set_value"];
    ImageUploadEditor.prototype["set_value"] = function (value: any) {
        if (typeof value === "string") {
            value = trimToNull(value);
            if (value != null) {
                var idx = value.indexOf('/');
                if (idx < 0)
                    value = value.indexOf('\\');
                value = <UploadedFile>{
                    Filename: value,
                    OriginalName: value.subString(idx + 1)
                }
            }
        }
        else if (isTrimmedEmpty(value.FileName))
            value = null;

        oldSetValue.call(this, value);
    }
})();
